import { checkIsInternalCompany } from 'app/auth/authUtils';
import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { getProgramsCategory } from './programsCategory.selectors';

export const selectPrograms = createSelector(getProgramsCategory, ({ programs }) => programs);

export const selectProgramsValues = createSelector(selectPrograms, Object.values);

const selectGlobalPrograms = createSelector(selectProgramsValues, programs =>
  programs.filter(({ companyId }) => checkIsInternalCompany({ companyId })),
);

const selectLocalPrograms = createSelector(selectProgramsValues, programs =>
  programs.filter(({ companyId }) => !checkIsInternalCompany({ companyId })),
);

export const selectProgramInternalNamesByParams = memoizeOne((companyId, programId) =>
  createSelector([selectGlobalPrograms, selectLocalPrograms], (globalPrograms, localPrograms) => {
    const isInternalCompany = checkIsInternalCompany({ companyId });
    const programs = isInternalCompany ? globalPrograms : localPrograms;

    return programs.reduce((acc, program) => {
      if (program.programId !== programId) {
        acc.push(program.internalName.toLowerCase());
      }

      return acc;
    }, []);
  }),
);
